'use strict';

var _ = require('lodash');
var ServiceOpportunitiesAggregationFactory = function ServiceOpportunitiesAggregationFactory($filter, momentService, DataAggregationFactory) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function ServiceOpportunitiesAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'service-opportunities');
  }
  function averageTime(times) {
    if (times.length === 0) {
      return '';
    }
    var avg = 0;
    times.map(function (time) {
      var currentTime = time.match(/\d\d/g);
      avg += currentTime[0] * 60 + parseInt(currentTime[1]);
    });
    avg = avg / times.length;
    var moment = momentService.now(momentService.TYPE.LOCAL_DATE_TIME).setHour(parseInt(avg / 60)).setMinute(parseInt(avg % 60));
    return rmMomentFormat(moment, momentService.TIME_USER_SETTINGS);
  }
  ServiceOpportunitiesAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ServiceOpportunitiesAggregation.constructor = ServiceOpportunitiesAggregation;
  ServiceOpportunitiesAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ServiceOpportunitiesAggregation.prototype.aggregate = function (data, metricsKeys) {
    var grouped = {};
    var groupedArray = [];
    var index, dataLength, groupedLength, current;
    var self = this;
    for (index = 0, dataLength = data.length; index < dataLength; index++) {
      current = data[index];
      var target = grouped[current.service];
      target = target || {};
      target.service = current.service;
      target.departureTime = target.departureTime || [];
      target.departureTime.push(current.departureTime);
      target.potentialRevenue = (target.potentialRevenue || 0) + self.getMetricValue(current.potentialRevenue, metricsKeys);
      target.recapRevGap = (target.recapRevGap || 0) + self.getMetricValue(current.recapRevGap, metricsKeys);
      target.spillRevGap = (target.spillRevGap || 0) + self.getMetricValue(current.spillRevGap, metricsKeys);
      grouped[current.service] = target;
    }
    var groupedKeys = Object.keys(grouped);
    for (index = 0, groupedLength = groupedKeys.length; index < groupedLength; index++) {
      current = grouped[groupedKeys[index]];
      current.departureTime = averageTime(current.departureTime);
      current.potentialRevenue = _.round(current.potentialRevenue, 2);
      current.recapRevGap = _.round(current.recapRevGap, 2);
      current.spillRevGap = _.round(current.spillRevGap, 2);
      groupedArray.push(current);
    }
    return self.sortBy(groupedArray, 'potentialRevenue', 'DESC');
  };
  return ServiceOpportunitiesAggregation;
};
ServiceOpportunitiesAggregationFactory.$inject = ['$filter', 'MomentService', 'AbstractROMServiceAggregationFactory'];
module.exports = ServiceOpportunitiesAggregationFactory;